import { useState } from 'react';
import {
  Button,
  CloseButton,
  Dialog,
  Portal,
  Text,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import api from '@services/api';
import type { PortfolioType } from '@customTypes/portfolio';

type Props = {
  portfolio: PortfolioType;
  handleClose: () => void;
  afterSubmit: () => void;
};

const ConfirmDisableDialog = ({ portfolio, handleClose, afterSubmit }: Props) => {
  const [loading, setLoading] = useState(false);

  const onDeleteClick = async () => {
    setLoading(true);
    try {
      const response = await api.delete(`/portfolio/${portfolio.id}`);

      if (response.status === 200) {
        toast.success('Portfólio desabilitado com sucesso.');
        afterSubmit();
      } else {
        toast.error('Erro ao desabilitar portfólio. Tente novamente!');
      }
    } catch {
      toast.error('Erro ao desabilitar portfólio. Tente novamente!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={handleClose}
      closeOnInteractOutside={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg">
            <Dialog.Header>
              <Dialog.Title>
                Tem certeza que deseja desabilitar o portfólio
                {' '}
                {portfolio.name}
                ?
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text color="fg.muted">
                Esta ação não pode ser desfeita. Qualquer item que faça referência
                a este portfólio perderá essa associação.
              </Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline" disabled={loading}>Cancelar</Button>
              </Dialog.ActionTrigger>
              <Button bg="red.500" color="white" onClick={onDeleteClick} loading={loading}>
                Desabilitar
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmDisableDialog;
